let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f0to4")).then(() => parcelRequire('96xO4'));